import { render, staticRenderFns } from "./ElProductTitle.vue?vue&type=template&id=d9e822a6"
import script from "./ElProductTitle.vue?vue&type=script&lang=js"
export * from "./ElProductTitle.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports